var _circle, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileHam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.87,
    cx: 6,
    cy: 6,
    r: 6,
    transform: "matrix(1 0 0 -1 0 12)",
    fill: "#D6D6D6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.4,
    x2: 7.2,
    y2: -0.4,
    transform: "matrix(1 0 0 -1 2.39941 7.7998)",
    stroke: "#6A6A6A",
    strokeWidth: 0.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.4,
    x2: 7.2,
    y2: -0.4,
    transform: "matrix(1 0 0 -1 2.39941 5.40039)",
    stroke: "#6A6A6A",
    strokeWidth: 0.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.4,
    x2: 7.2,
    y2: -0.4,
    transform: "matrix(1 0 0 -1 2.39941 2.99951)",
    stroke: "#6A6A6A",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileHam);
export default __webpack_public_path__ + "static/media/profileHam.3fc0354d73e760ce18c3cbd9509b86c5.svg";
export { ForwardRef as ReactComponent };